import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Typography from "@mui/material/Typography";
import CustomerActivityComment from "./CustomerActivityComment";
import { api_path } from "../../shared";
const CustomerActivityTimeline = ({
  CUSTOMER_CODE,
  USER_ID,
  EMP_CODE,
  USER_ROLE,
}) => {
  const location = useLocation();
  const commentBoxRef = useRef(null);
  // ✅ ดึง query params
  const params = new URLSearchParams(location.search);
  const customerId = params.get("customer_id");
  const activityId = params.get("activity_id");
  const [activities, setActivities] = useState([]);
  const token = process.env.REACT_APP_API_TOKEN;
  const queryParams = new URLSearchParams({
    CID: CUSTOMER_CODE,
    CRM_UID: USER_ID,
    ROLE_ID: USER_ROLE,
    // CRM_UID: USER_ID || 0,
    //EMP_CODE: "",
    //EMP_CODE: EMP_CODE || "",
    //SALES_ACTIVITY_ID: 0,
    // ACTIVITY_DATE_FROM: "",
    // ACTIVITY_DATE_TO: "",
  });
  useEffect(() => {
    const fetchActivities = async () => {
      const queryString = queryParams.toString();
      const url = `${api_path}/customer/customer_activities.php?${queryString}`;
      console.log("🔍 Full Fetch URL:", url);
      try {
        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await response.json();
        //console.log("✅ Fetched activity result:", result);
        //console.log("✅ acts:", result); // <--- ดูตรงนี้
        if (result) {
          setActivities(result);
        } else {
          console.warn("⚠️ No activities found in response");
        }
        console.log("🌟 Activities raw:", result);
        console.log("✅ Array check:", Array.isArray(result));
      } catch (error) {
        console.error("❌ Error fetching activities:", error);
      }
    };

    //console.log("🔍 CUSTOMER_CODE:", CUSTOMER_CODE);
    if (CUSTOMER_CODE) {
      fetchActivities();
    }
  }, [CUSTOMER_CODE]);
  const hasValue = activities.some(
    (item) => item?.value && item.value.toString().trim() !== ""
  );

  // เมื่อเปิดหน้าแล้วมี activity_id → scroll ไปที่ comment นั้น
  useEffect(() => {
    if (activityId) {
      // รอ DOM โหลดเสร็จก่อนค่อย scroll (เผื่อ data render ช้า)
      const timer = setTimeout(() => {
        const target = document.getElementById(`comment-${activityId}`);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "center" });

          // ✅ Highlight comment box ชั่วคราว
          target.style.transition = "background-color 0.5s ease";
          target.style.backgroundColor = "#EBEBEB";
          setTimeout(() => {
            target.style.backgroundColor = "transparent";
          }, 2000);
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [activityId]);

  return (
    <div className="">
      {hasValue ? <h4>Activity Timeline</h4> : <p></p>}
      <div className="timeline-item-v2-component">
        {activities.map((item, index) => (
          <div
            key={item.SALES_ACTIVITY_ID}
            id={`comment-${item.SALES_ACTIVITY_ID}`} // 👈 id สำหรับ scroll
            className="timeline-item-v2-component-box"
          >
            {/* <div key={index} className="timeline-item-v2-component-box" ref={commentBoxRef} id="commentBox">        */}
            <div className="timeline-item-event-header-wrapper">
              <div class="icon-thumbnail-component timeline-item-icon">
                <CalendarMonthIcon />
              </div>
              <div class="timeline-item-date-wrapper">
                <div className="timeline-date-v2-component">
                  <div
                    className={`status-button badge activity-${item.ACTIVITY_NAME.toLowerCase().replace(
                      /\s/g,
                      "-"
                    )}`}
                  >
                    {item.ACTIVITY_NAME}
                  </div>
                  <b>{item.CREATE_BY}</b> &nbsp;&nbsp;
                  {dateFormat(item.ACTIVITY_DATE, "dd/mm/yy HH:MM")}
                </div>
              </div>
            </div>
            <div className="timeline-item-content-wrapper2">
              <div className="timeline-item-header-title">
                <div>
                  <b> {item.TOPIC}</b>
                </div>
                <p>
                  {" "}
                  <b>
                    Reminder:{" "}
                    {item.REMINDER && !item.REMINDER.includes("1900")
                      ? dateFormat(new Date(item.REMINDER), "dd/mm/yy HH:MM")
                      : "-"}
                  </b>
                </p>
                <Typography sx={{ whiteSpace: "pre-wrap" }}>
                  {item.DESCRIPTION && <p className="">{item.DESCRIPTION}</p>}
                </Typography>

                <div></div>
              </div>
              {/* ✅ ส่ง highlightActivityId เข้า CustomerActivityComment */}
              <CustomerActivityComment
                CRM_CUSCODE={item.CRM_CUSCODE}
                SALES_ACTIVITY_ID={item.SALES_ACTIVITY_ID}
                FROM="CUSTOMER"
                highlightActivityId={activityId}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerActivityTimeline;
